module.exports = __webpack_public_path__ + "img/闪电01.6a27124c.svg";